import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import "../result/result.css";
import { Link } from "react-router-dom";
import printJS from "print-js"; // If using npm
import AlertMessage from "../../AlertMessage";

import { useParams } from "react-router-dom";



function WebPrelimResult() {
  const params = useParams();
  const udiseNumber = params.udiseNumber;
  const srNo = params.srNo;
  const [academicYear, setAcademicYear] = useState(params.academicYear || "");
  const [classValue, setClassValue] = useState(params.classValue || "");
  const [division, setDivision] = useState(params.division || "");
  const selectedExamName = params.selectedExamName;
  const rollNo = params.rollNo;
  const [studentData, setStudentData] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [marksData, setMarksData] = useState({});
  const [classes, setClasses] = useState([]);
  const [selectedStudentResults, setSelectedStudentResults] = useState(null);
  const [showModal, setShowModal] = useState(true);
  const [schoolName, setSchoolName] = useState("");
  const [schoolLogo, setSchoolLogo] = useState("");
  const [divisions, setDivisions] = useState([]);
  const [divisionSubjects, setDivisionSubjects] = useState({}); // Store subjects by class and division

  const [examNames, setExamNames] = useState([
    "Prelim Exam-I",
    "Prelim Exam-II",
    "Prelim Exam-III",
    "Prelim Exam-IV",

    "Semester Second ",
  ]);

  const examNameTranslations = {
    "Prelim Exam-I": "पूर्वपरीक्षा-1",
    "Prelim Exam-II": "पूर्वपरीक्षा-2",
    "Prelim Exam-III": "पूर्वपरीक्षा-3",
    "Prelim Exam-IV": "पूर्वपरीक्षा-4",

    "Semester Second ": "द्वितीय सत्र",
  };

 
  
    // Fetch subject sequence on mount
    useEffect(() => {
      // Retrieve persisted values from localStorage on component mount
      const storedAcademicYear = localStorage.getItem("academicYear");
      const storedClassValue = localStorage.getItem("classValue");
      const storedDivision = localStorage.getItem("division");

      if (storedAcademicYear) setAcademicYear(storedAcademicYear);
      if (storedClassValue) setClassValue(storedClassValue);
      if (storedDivision) setDivision(storedDivision);

      if (academicYear && classValue && division) {
        fetchSubjectSequence();
      }
    }, [academicYear, classValue, division]);

    // Persist values to localStorage whenever they change
    useEffect(() => {
      if (academicYear) localStorage.setItem("academicYear", academicYear);
      if (classValue) localStorage.setItem("classValue", classValue);
      if (division) localStorage.setItem("division", division);
    }, [academicYear, classValue, division]);
  
    // Fetch student data on mount
   
    const [loading, setLoading] = useState(true); // Add a loading state

useEffect(() => {
  const fetchData = async () => {
    try {
      setLoading(true); // Set loading to true before fetching data
      await fetchStudentData(); // Fetch student data
      setLoading(false); // Set loading to false after data is fetched
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false); // Ensure loading is set to false even if there's an error
    }
  };

  fetchData();
}, [srNo, udiseNumber, academicYear, selectedExamName]);
   

    // Fetch school info
    const fetchSchoolInfo = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData.json`
        );
        if (response.ok) {
          const data = await response.json();
          setSchoolName(data.schoolName || "");
          setSchoolLogo(data.schoolLogo || "");
        }
      } catch (error) {
        console.error("Error fetching school info:", error);
      }
    }; 
    
    


    // Save selectedStudentResults to localStorage whenever it changes
// ...existing code...

useEffect(() => {
  // Retrieve selectedStudentResults from localStorage on component mount
  const savedResults = localStorage.getItem('selectedStudentResults');
  if (savedResults) {
    setSelectedStudentResults(JSON.parse(savedResults));
  }
}, []);

// Ensure selectedStudentResults is saved to localStorage whenever it changes
useEffect(() => {
  if (selectedStudentResults) {
    localStorage.setItem('selectedStudentResults', JSON.stringify(selectedStudentResults));
  }
}, [selectedStudentResults]);

// Clear localStorage when the modal is closed
const handleCloseModal = () => {
  localStorage.removeItem('selectedStudentResults');
  setShowModal(false);
};

// ...existing code...
  
    // Fetch subject sequence
    const fetchSubjectSequence = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/subjectSequence/icse/${academicYear}/${classValue}/${division}.json`
        );
        if (response.ok) {
          const data = await response.json();
          const orderedSubjects = Object.values(data || {});
          setSubjectSequence(orderedSubjects);
        }
      } catch (error) {
        console.error("Error fetching subject sequence:", error);
      }
    };


  
    // Calculate grade based on marks
    const calculateGrade = (total) => {
      if (language === "English") {
        if (total >= 90) return "A+";
        if (total >= 80) return "A";
        if (total >= 70) return "B+";
        if (total >= 60) return "B";
        if (total >= 50) return "C+";
        if (total >= 40) return "C";
        if (total >= 30) return "D+";
        if (total >= 20) return "D";
        return "Fail";
      } else {
        if (total >= 90) return "अ-1";
        if (total >= 80) return "अ-2";
        if (total >= 70) return "ब-1";
        if (total >= 60) return "ब-2";
        if (total >= 50) return "क-1";
        if (total >= 40) return "क-2";
        if (total >= 30) return "ड-1";
        if (total >= 20) return "ड-2";
        return "नापास";
      }
    };
  

  // Reset divisions when class changes
  useEffect(() => {
    if (classValue) {
      const divisionsForClass = studentData
        .filter((student) => student.currentClass === classValue)
        .map((student) => student.division)
        .filter((value, index, self) => value && self.indexOf(value) === index);
      setDivisions(divisionsForClass);
    } else {
      setDivisions([]);
    }
  }, [classValue, studentData]);

  useEffect(() => {
    const fetchDefaultSettings = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/defaultSettings.json`
        );
        if (response.ok) {
          const data = await response.json();

          if (data) {
            // setAcademicYear(data.defaultYear || "");
          }
        } else {
          console.error("Failed to fetch default settings.");
        }
      } catch (error) {
        console.error("Error fetching default settings:", error);
      }
    };

    fetchDefaultSettings();
  }, [udiseNumber]);
  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "English"
  );

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);

  const [subjectSequence, setSubjectSequence] = useState([]); // New state for subject sequence


  useEffect(() => {
    const storedLanguage = localStorage.getItem("language") || "English";
    setLanguage(storedLanguage);
  }, []);

  const fetchSchoolName = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData.json`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch school name");
      }
      const data = await response.json();
      setSchoolName(data.schoolName || "-");
      setSchoolLogo(data.schoolLogo || ""); // Add this line
    } catch (error) {
      console.error("Error fetching school name:", error);
    }
  };


  const fetchStudentData = async () => {
    try {
      // Retrieve persisted results from localStorage
      const savedResults = localStorage.getItem('selectedStudentResults');
      if (savedResults) {
        setSelectedStudentResults(JSON.parse(savedResults));
        setShowModal(true);
        return;
      }

      // Fetch first semester data
      const firstSemesterResponse = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/result/${academicYear}/First Semester.json`
      );

      if (!firstSemesterResponse.ok) {
        throw new Error("Failed to fetch first semester data");
      }

      const firstSemesterData = await firstSemesterResponse.json();

      // Fetch second semester data
      const secondSemesterResponse = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/result/${academicYear}/${selectedExamName}.json`
      );

      if (!secondSemesterResponse.ok) {
        throw new Error("Failed to fetch second semester data");
      }

      const secondSemesterData = await secondSemesterResponse.json();

      // Fetch nondi data for both semesters
      const nondiFirstSemesterResponse = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/result/${academicYear}/First Semester/nondi.json`
      );

      const nondiSecondSemesterResponse = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/result/${academicYear}/${selectedExamName}/nondi.json`
      );

      if (!nondiFirstSemesterResponse.ok || !nondiSecondSemesterResponse.ok) {
        throw new Error("Failed to fetch nondi data");
      }

      const nondiFirstSemesterData = await nondiFirstSemesterResponse.json();
      const nondiSecondSemesterData = await nondiSecondSemesterResponse.json();

      // Process the results
      const resultsWithTotal = {};
      const allSubjects = new Set([
        ...Object.keys(firstSemesterData || {}),
        ...Object.keys(secondSemesterData || {}),
      ]);

      allSubjects.forEach((subject) => {
        const firstSemesterGrade = firstSemesterData?.[subject]?.Akarik?.Total
          ? calculateGrade(
              firstSemesterData[subject].Akarik.Total +
                (firstSemesterData[subject].Sanklik?.Total || 0)
            )
          : " ";

        const akarikTotal = secondSemesterData?.[subject]?.Akarik?.Total || 0;
        const sankalikTotal =
          secondSemesterData?.[subject]?.Sanklik?.Total || 0;
        const total = akarikTotal + sankalikTotal;
        const grade = calculateGrade(total);

        resultsWithTotal[subject] = {
          akarikTotal,
          sankalikTotal,
          total,
          grade,
          firstSemesterGrade,
        };
      });

      // Create a complete student result object
      const studentResult = {
        results: resultsWithTotal,
        nondi: nondiSecondSemesterData || {},
        firstSemester: nondiFirstSemesterData || {},
        // Include student information
        studentName: selectedStudentResults?.studentName || "",
        stdMother: selectedStudentResults?.stdMother || "",
        stdFather: selectedStudentResults?.stdFather || "",
        stdSurname: selectedStudentResults?.stdSurname || "",
        dob: selectedStudentResults?.dob || "",
        division: selectedStudentResults?.division || "",
        motherTounge: selectedStudentResults?.motherTounge || "",
        studentId: selectedStudentResults?.studentId || "",
        gender: selectedStudentResults?.gender || "",
        rollNo: selectedStudentResults?.rollNo || "",
      };

      // Save complete data to localStorage
      localStorage.setItem('selectedStudentResults', JSON.stringify(studentResult));

      // Update the state with the results
      setSelectedStudentResults(studentResult);
      setShowModal(true);
    } catch (error) {
      console.error("Error fetching student data:", error);
    }
  };

  const fetchAllStudentData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData.json`
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      const filteredData = Object.keys(data)
        .filter((key) => data[key] !== null)
        .map((key) => ({ srNo: key, ...data[key] }));

      setStudentData(filteredData);

      const classSet = new Set();
      const divisionSet = new Set();

      filteredData.forEach((student) => {
        if (student.currentClass) {
          classSet.add(String(student.currentClass));
        }
        if (student.division) {
          divisionSet.add(student.division);
        }
      });

      setClasses([...classSet]);
      setDivisions([...divisionSet]);
    } catch (error) {
      console.error("Error fetching all student data:", error);
    }
  };


  
  useEffect(() => {
    fetchSchoolName();
    fetchStudentData();
  }, []);


  
  useEffect(() => {
    const fetchStudentData = async () => {
      try {
        if (srNo && udiseNumber && academicYear && selectedExamName) {
          // Fetch basic student info
          const response = await fetch(
            `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}.json`
          );
          if (!response.ok) {
            throw new Error("Failed to fetch student info");
          }
          const studentInfo = await response.json();

          // Fetch marks data
          const marksResponse = await fetch(
            `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/icseResult/${academicYear}/${selectedExamName}.json`
          );
          if (!marksResponse.ok) {
            throw new Error("Failed to fetch marks data");
          }
          const marksData = await marksResponse.json();

          // Process results
          const processedResults = {};
          Object.entries(marksData || {}).forEach(([subject, data]) => {
            processedResults[subject] = {
              outOf: data.outOf || 0,
              obtainMarks: data.obtainMarks || 0,
              minMarks: data.minMarks || 0,
            };
          });
  
          // Set student results
          setSelectedStudentResults({
            ...studentInfo,
            results: processedResults,
            studentName: studentInfo.stdName,
            stdMother: studentInfo.stdMother,
            stdFather: studentInfo.stdFather,
            stdSurname: studentInfo.stdSurname,
            dob: studentInfo.dob,
            division: studentInfo.division,
            motherTounge: studentInfo.motherTounge,
            studentId: studentInfo.studentId,
            gender: studentInfo.gender,
            rollNo: studentInfo.rollNo,
          });
  
          // Fetch school info
          await fetchSchoolInfo();
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setAlertMessage("Failed to load student data");
        setShowAlert(true);
      }
    };
  
    fetchStudentData();
  }, [srNo, udiseNumber, academicYear, selectedExamName]);

  useEffect(() => {
    if (selectedExamName && classValue && academicYear) {
      fetchMarksForSelectedSubject();
    }
  }, [selectedExamName, classValue, academicYear]);

  const filteredExamNames = examNames.filter(
    (examName) => examName === "Semester Second "
  );

 

  const fetchSubjectsForClassAndDivision = async (classValue, division) => {
    try {
      if (!classValue || !division || !academicYear) {
        console.error("Class, division, or academic year not set");
        return;
      }

      const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/subjectSequence/icse/${academicYear}/${classValue}/${division}.json`;
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(
          `Failed to fetch subjects for class ${classValue} and division ${division}`
        );
      }
      const subjectsData = await response.json();
      if (subjectsData) {
        const validSubjects = Object.entries(subjectsData)
          .filter(([_, value]) => value !== null && value !== undefined)
          .map(([_, subject]) => subject);

        setDivisionSubjects((prev) => ({
          ...prev,
          [classValue]: {
            ...prev[classValue],
            [division]: validSubjects,
          },
        }));
      } else {
        setDivisionSubjects((prev) => ({
          ...prev,
          [classValue]: {
            ...prev[classValue],
            [division]: [],
          },
        }));
      }
    } catch (error) {
      console.error(`Error fetching subjects: ${error}`);
    }
  };

  // Fetch subjects when class or division changes
  useEffect(() => {
    if (classValue && division) {
      fetchSubjectsForClassAndDivision(classValue, division);
    }
  }, [classValue, division, academicYear]);

  const fetchMarksForSelectedSubject = async () => {
    try {
      const selectedStudents = studentData.filter(
        (student) => student.currentClass === classValue
      );
      setSelectedStudents(selectedStudents);
      const marksDataPromises = selectedStudents.map(async (student) => {
        const studentMarks = await fetchMarksData(
          student.srNo,
          academicYear,
          selectedExamName
        );
        return { srNo: student.srNo, marks: studentMarks };
      });

      const marksDataArray = await Promise.all(marksDataPromises);
      const marksData = marksDataArray.reduce((acc, { srNo, marks }) => {
        acc[srNo] = marks;
        return acc;
      }, {});

      setMarksData(marksData);
    } catch (error) {
      console.error("Error fetching marks data:", error);
    }
  };

  const fetchMarksData = async (srNo, academicYear, examName) => {
    const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/icseResult/${academicYear}/${examName}.json`;
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Error fetching data: ${response.statusText}`);
      }
      const data = await response.json();
      return data || {};
    } catch (error) {
      console.error("Error fetching marks data:", error);
      return {};
    }
  };



   useEffect(() => {
      const fetchBasicStudentInfo = async () => {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}.json`
          );
          if (!response.ok) {
            throw new Error("Failed to fetch student info");
          }
          const studentInfo = await response.json();
  
          // Set basic student info
          setSelectedStudentResults((prev) => ({
            ...prev,
            studentName: studentInfo.stdName,
            stdMother: studentInfo.stdMother,
            stdFather: studentInfo.stdFather,
            stdSurname: studentInfo.stdSurname,
            dob: studentInfo.dob,
            division: studentInfo.division,
            motherTounge: studentInfo.motherTounge,
            studentId: studentInfo.studentId,
            gender: studentInfo.gender,
            rollNo: studentInfo.rollNo,
            stdPhoto: studentInfo.stdPhoto,
          }));
        } catch (error) {
          console.error("Error fetching student info:", error);
        }
      };
  
      if (srNo) {
        fetchBasicStudentInfo();
      }
    }, [srNo, udiseNumber]);


  const [selectedStudentForSr, setSelectedStudentForSr] = useState("");

  const viewResult = async (srNo) => {
    try {
      const student = selectedStudents.find((student) => student.srNo === srNo);
      setSelectedStudentForSr(student);
      if (!student) {
        throw new Error("Student not found");
      }

      // Fetch both first and second semester data
      const firstSemesterResponse = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/result/${academicYear}/First Semester.json`
      );
      const secondSemesterResponse = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/result/${academicYear}/${selectedExamName}.json`
      );

      if (!firstSemesterResponse.ok || !secondSemesterResponse.ok) {
        throw new Error("Network response was not ok");
      }

      const firstSemesterData = await firstSemesterResponse.json();
      const secondSemesterData = await secondSemesterResponse.json();

      // Check if either semester data is empty
      if (!firstSemesterData || Object.keys(firstSemesterData).length === 0) {
        setAlertMessage(
          "Add the subject and fill the marks to view the result."
        );
        return; // Exit the function if no data is found
      }

      if (!secondSemesterData || Object.keys(secondSemesterData).length === 0) {
        setAlertMessage(
          "Add the subject and fill the marks to view the result."
        );
        return; // Exit the function if no data is found
      }

      const resultsWithTotal = {};

      // Combine all subjects from both semesters
      const allSubjects = new Set([
        ...Object.keys(firstSemesterData),
        ...Object.keys(secondSemesterData),
      ]);

      allSubjects.forEach((subject) => {
        const firstSemesterGrade = firstSemesterData[subject]?.Akarik?.Total
          ? calculateGrade(
              firstSemesterData[subject].Akarik.Total +
                (firstSemesterData[subject].Sanklik?.Total || 0)
            )
          : " ";

        const akarikTotal = secondSemesterData[subject]?.Akarik?.Total || 0;
        const sankalikTotal = secondSemesterData[subject]?.Sanklik?.Total || 0;
        const total = akarikTotal + sankalikTotal;
        const grade = calculateGrade(total);

        resultsWithTotal[subject] = {
          akarikTotal,
          sankalikTotal,
          total,
          grade,
          firstSemesterGrade,
        };
      });

      // Fetch nondi data for both semesters
      const nondiFirstSemesterResponse = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/result/${academicYear}/First Semester/nondi.json`
      );

      const nondiSecondSemesterResponse = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/result/${academicYear}/${selectedExamName}/nondi.json`
      );

      if (!nondiFirstSemesterResponse.ok || !nondiSecondSemesterResponse.ok) {
        throw new Error("Failed to fetch nondi data");
      }

      const nondiFirstSemesterData = await nondiFirstSemesterResponse.json();
      const nondiSecondSemesterData = await nondiSecondSemesterResponse.json();

      // Set state with both semester data
      setSelectedStudentResults({
        studentName: student.stdName,
        results: resultsWithTotal,
        nondi: nondiSecondSemesterData || {},
        firstSemester: nondiFirstSemesterData || {},
        stdMother: student.stdMother,
        stdFather: student.stdFather,
        stdSurname: student.stdSurname,
        dob: student.dob,
        division: student.division,
        motherTounge: student.motherTounge,
        studentId: student.studentId,
        gender: student.gender,
        rollNo: student.rollNo,
      });

      setShowModal(true);
    } catch (error) {
      console.error("Error fetching student results:", error);
    }
  };
  const calculateGradeEnglish = (total) => {
    if (total >= 90) return "A+";
    if (total >= 80) return "A";
    if (total >= 70) return "B+";
    if (total >= 60) return "B";
    if (total >= 50) return "C+";
    if (total >= 40) return "C";
    if (total >= 30) return "D+";
    if (total >= 20) return "D";
    return "Fail";
  };

  const calculateGradeMarathi = (total) => {
    if (total >= 90) return "अ-1";
    if (total >= 80) return "अ-2";
    if (total >= 70) return "ब-1";
    if (total >= 60) return "ब-2";
    if (total >= 50) return "क-1";
    if (total >= 40) return "क-2";
    if (total >= 30) return "ड-1";
    if (total >= 20) return "ड-2";
    return "नापास";
  };

  // Function to calculate grade based on the current language




  //  setting marks to pass
  const getPassingMarks = (currentClass) => {
    if (
      selectedStudentForSr.currentClass === "Class V" ||
      selectedStudentForSr.currentClass === "इयत्ता पाचवी"
    ) {
      return 18;
    } else if (
      selectedStudentForSr.currentClass === "Class VIII" ||
      selectedStudentForSr.currentClass === "इयत्ता आठवी"
    ) {
      return 21;
    }
    // Default passing marks if none of the specified classes are selected
    return 18;
  };

  const passingMarks = getPassingMarks(selectedStudentForSr.currentClass);

  //percentage
  let totalSubjects = 0;
  let totalMarks = 0;
  let percentage = 0;

  if (selectedStudentResults && selectedStudentResults.results) {
    totalSubjects = Object.entries(selectedStudentResults.results).filter(
      ([subject]) => subject !== "nondi"
    ).length;

    totalMarks = Object.entries(selectedStudentResults.results)
      .filter(([subject]) => subject !== "nondi")
      .reduce(
        (acc, [subject, grades]) =>
          acc + (grades.sankalikTotal || 0) + (grades.akarikTotal || 0),
        0
      );

    percentage = (totalMarks / (totalSubjects * 100)) * 100;
  }



  return (
    <div>
      <AlertMessage message={alertMessage} show={showAlert} />

      <div className=" main-content-of-page">
        <h3 style={{ color: "rgb(27, 67, 50)", textAlign: "center" }}>
          {" "}
          {language === "English"
            ? "ICSE Exam Result "
            : " ICSE परीक्षेचा निकाल"}
        </h3>
        <table className="table table-striped table-bordered">
          <tbody>
            <tr>
              <th style={{ width: "calc(100% / 7)" }}>
                {" "}
                {language === "English" ? "Year " : "शैक्षणिक वर्ष  "}
              </th>
              <td>
                <select
                  id="academicYear"
                  defaultValue={academicYear} // Add this prop
                  value={academicYear}
                  //   onChange={handleAcademicYearChange}
                  className="form-control custom-select"
                >
                  <option>
                    {language === "English" ? "Select Year " : "वर्ष निवडा "}
                  </option>
                  <option value="2023-2024">2023-2024</option>
                  <option value="2024-2025" selected>
                    2024-2025
                  </option>
                  <option value="2025-2026">2025-2026</option>
                  <option value="2026-2027">2026-2027</option>
                </select>
              </td>
            </tr>
            <tr>
              <th> {language === "English" ? "Class " : "वर्ग"}</th>
              <td>
                <select
                  id="class"
                  value={classValue}
                  //   onChange={handleClassChange}
                  className="form-control custom-select"
                >
                  <option value="">
                    {language === "English" ? "Select Class " : "वर्ग निवडा"}
                  </option>
                  {classes.map((cls, index) => (
                    <option key={index} value={cls}>
                      {cls}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
            <tr>
              <th>{language === "English" ? "Division " : "विभाग"}</th>
              <td>
                <select
                  id="division"
                  value={division}
                  //   onChange={(e) => setDivision(e.target.value)}
                  className="form-control custom-select"
                >
                  <option value="">
                    {language === "English"
                      ? "Select Division "
                      : "विभाग निवडा"}
                  </option>
                  {divisions.map((div, index) => (
                    <option key={index} value={div}>
                      {div}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
            <tr>
              <th>{language === "English" ? "Exam Name " : "परीक्षा"}</th>
              <td>
                <select
                  id="examName"
                  value={selectedExamName}
                  //   onChange={handleExamNameChange}
                  className="form-control custom-select"
                >
                  <option value="">
                    {language === "English" ? "Select Exam" : "परीक्षा निवडा"}
                  </option>
                  {examNames.map((examName, index) => (
                    <option key={index} value={examName}>
                      {language === "English"
                        ? examName
                        : examNameTranslations[examName]}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
          </tbody>
        </table>

        {selectedStudents.length > 0 && (
          <div className="mt-4">
            <table className="table table-striped table-bordered custom-table">
              <thead>
                <tr>
                  <th className="custom-width">
                    {language === "English" ? "Roll No " : "हजेरी क्र"}
                  </th>
                  <th>
                    {language === "English"
                      ? "Student Name "
                      : "विद्यार्थ्याचे नाव"}
                  </th>
                  <th>
                    {language === "English" ? "icseResult " : "प्रगतीपत्रक"}
                  </th>
                </tr>
              </thead>
              <tbody>
                {selectedStudents
                  .filter((student) => student.division === division)
                  .sort((a, b) => a.rollNo - b.rollNo)
                  .map((student) => (
                    <tr key={student.srNo}>
                      <td>{student.rollNo}</td>
                      <td>
                        {student.stdName} {student.stdSurname}
                      </td>
                      <td>
                        <button
                          className="btn btn-primary"
                          onClick={() => viewResult(student.srNo)}
                        >
                          {language === "English"
                            ? "View icseResult"
                            : "प्रगति पत्रक"}
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}

        <Modal
          show={showModal}
          onHide={handleCloseModal}
          dialogClassName="modal-80w"
        >
         
          <Modal.Body>
            {selectedExamName === "Second " && selectedStudentResults ? (
              <div>
                {/* Semester Second  modal content */}
                <div className="r mt-1" style={{}}></div>
              </div>
            ) : (
              <div>
                {/* Semester First  modal content */}
                <div className="r mt-1" style={{}}>
                  <div
                    className="left"
                    style={{
                      width: "615px",
                      height: "900px",
                      margin: "0 auto", // Center the div horizontally
                      padding: "20px", // Add some padding
                      border: "2px solid #000", // Optional: Add a border for visibility
                      boxSizing: "border-box", // Include padding and border in the element's total width and height
                      overflow: "hidden", // Prevent overflow if content is too large
                    }}
                  >
                    <div className="school-info">
                      {schoolLogo && (
                        <div>
                          <img
                            src={schoolLogo}
                            alt="Logo"
                            style={{
                              width: "80px",
                              height: "auto",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      )}

                      <h2>{schoolName}</h2>
                    </div>

                    <div>
                      <hr
                        style={{
                          width: "calc(100% + 40px)", // Adjust width to account for padding
                          height: "2px",
                          backgroundColor: "black",
                          border: "none",
                          marginLeft: "-20px", // Negative margin to pull it to the left
                          marginRight: "-20px", // Negative margin to pull it to the right
                          marginBottom: "6px", // Adjust this value to reduce the gap below the hr
                        }}
                      />
                      <b>
                        <h6 style={{ textAlign: "center", margin: "0" }}>
                          {" "}
                          {/* Set margin to 0 */}
                          {language === "English"
                            ? "PROGRESS REPORT"
                            : "विद्यार्थी प्रगती अहवाल"}
                        </h6>
                        <h6 style={{ textAlign: "center", margin: "0" }}>
                          {" "}
                          {/* Set margin to 0 */}
                          {language === "English"
                            ? `${
                                selectedExamName || "-"
                              }  EXAMINATION - ${academicYear}`
                            : `प्रथम सत्र परीक्षा-  ${academicYear}`}
                        </h6>
                      </b>
                      <hr
                        style={{
                          width: "calc(100% + 40px)",
                          height: "2px",
                          backgroundColor: "black",
                          border: "none",
                          marginLeft: "-20px",
                          marginRight: "-20px",
                          marginTop: "6px",
                          marginBottom: "6px",
                        }}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        fontSize: "14px",
                      }}
                    >
                      <div style={{ flex: "1", textAlign: "left" }}>
                        <label htmlFor="roll-no" style={{ fontSize: "14px" }}>
                          {language === "English"
                            ? "Roll No : "
                            : "हजेरी क्रमांक : "}
                        </label>
                        <span>{selectedStudentResults?.rollNo || "-"}</span>
                      </div>
                      <div style={{ flex: "1", textAlign: "center" }}>
                        <label
                          htmlFor="Register No"
                          style={{ fontSize: "14px" }}
                        >
                          {language === "English"
                            ? "Register No : "
                            : "रजिस्टर क्रमांक : "}
                        </label>
                        <span>{selectedStudentResults?.registerNo || "-"}</span>
                      </div>
                      <div style={{ flex: "1", textAlign: "right" }}>
                        <label htmlFor="class" style={{ fontSize: "14px" }}>
                          {language === "English" ? "Class : " : "वर्ग : "}
                        </label>
                        <span>
                          {classValue || "-"}{" "}
                          {selectedStudentResults?.division || "-"}{" "}
                        </span>
                      </div>
                    </div>
                    <hr
                      style={{
                        width: "calc(100% + 40px)",
                        height: "2px",
                        backgroundColor: "black",
                        border: "none",
                        marginLeft: "-20px",
                        marginRight: "-20px",
                        marginTop: "1px",
                      }}
                    />
                    <div
                      style={{
                        fontSize: "14px",
                        marginLeft: "30px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ width: "70%" }}>
                        <div>
                          <label
                            htmlFor="student-name"
                            style={{ fontSize: "14px" }}
                          >
                            {language === "English"
                              ? "Student Name : "
                              : "विद्यार्थ्याचे नाव : "}
                          </label>
                          <span>
                            {selectedStudentResults?.studentName || "-"}{" "}
                            {selectedStudentResults?.stdFather || "-"}{" "}
                            {selectedStudentResults?.stdSurname || "-"}
                          </span>
                        </div>
                        <div>
                          <label htmlFor="class" style={{ fontSize: "14px" }}>
                            {language === "English"
                              ? "Mother Name : "
                              : "आईचे वर्ग : "}
                          </label>
                          <span>
                            {selectedStudentResults?.stdMother || "-"}{" "}
                          </span>
                        </div>
                        <div>
                          <label htmlFor="class" style={{ fontSize: "14px" }}>
                            {language === "English"
                              ? "Date Of Birth : "
                              : "जन्मतारीख : "}
                          </label>
                          <span>{selectedStudentResults?.dob ? selectedStudentResults.dob.split('-').reverse().join('-') : "-"} </span>
                        </div>
                        <div>
                          <label
                            htmlFor="exam-roll-no"
                            style={{ fontSize: "14px" }}
                          >
                            {language === "English"
                              ? "Exam : "
                              : "परीक्षा सत्र : "}
                          </label>
                          <span>{selectedExamName || "-"}</span>
                        </div>
                      </div>
                      <div style={{ width: "30%" }}>
                        {selectedStudentResults?.stdPhoto && (
                          <img
                            src={selectedStudentResults?.stdPhoto}
                            style={{ width: "80px", height: "80px" }}
                          />
                        )}
                      </div>
                    </div>
                    {selectedStudentResults?.results ? (
                      <table
                        className="table table-striped table-bordered"
                        style={{ fontSize: "12px", padding: "5px" }}
                      >
                        <thead>
                          <tr>
                            <th
                              rowSpan="1"
                              style={{ padding: "3px", color: "black" }}
                            >
                              {language === "English" ? "Subject" : "विषय"}
                            </th>
                            <th style={{ padding: "4px", color: "black" }}>
                              {language === "English" ? "Max. Marks" : "पैकी"}
                            </th>
                            <th style={{ padding: "4px", color: "black" }}>
                              {language === "English"
                                ? "Min. Marks"
                                : "किमान गुण"}
                            </th>
                            <th style={{ padding: "4px", color: "black" }}>
                              {language === "English" ? "Obtain Marks" : "गुण"}
                            </th>
                            <th
                              rowSpan="1"
                              style={{ padding: "3px", color: "black" }}
                            >
                              {language === "English" ? "P %" : "%"}
                            </th>
                            <th
                              rowSpan="1"
                              style={{ padding: "3px", color: "black" }}
                            >
                              {language === "English" ? "Grade" : "श्रेणी"}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedStudentResults &&
                          selectedStudentResults.results ? (
                            subjectSequence
                              .filter((subject) => {
                                const grades =
                                  selectedStudentResults.results[subject];
                                // Only include subjects where at least one of the grade fields has a valid value (not null or undefined)
                                return (
                                  grades &&
                                  (grades.unitTestIObtainMarks ||
                                    grades.unitTestIIObtainMarks ||
                                    grades.obtainMarks)
                                );
                              })
                              .map((subject) => {
                                const grades =
                                  selectedStudentResults.results[subject];
                                // Calculate row-wise totals and percentage
                                const totalOutOf = grades.outOf || 0;
                                const totalObtainMarks =
                                  grades.obtainMarks || 0;
                                const rowPercentage =
                                  totalOutOf > 0
                                    ? (
                                        (totalObtainMarks / totalOutOf) *
                                        100
                                      ).toFixed(2)
                                    : "-";
                                // Calculate grade based on the row percentage
                                const grade =
                                  rowPercentage !== "-"
                                    ? calculateGrade(Number(rowPercentage))
                                    : "-";

                                return (
                                  <tr key={subject} style={{ padding: "2px" }}>
                                    <td
                                      style={{ padding: "2px", color: "black" }}
                                    >
                                      {subject}
                                    </td>
                                    <td
                                      style={{ padding: "2px", color: "black" }}
                                    >
                                      {grades.outOf || "-"}
                                    </td>
                                    <td
                                      style={{ padding: "2px", color: "black" }}
                                    >
                                      {grades.minMarks || "-"}
                                    </td>
                                    <td
                                      style={{ padding: "2px", color: "black" }}
                                    >
                                      {grades.obtainMarks || "-"}
                                    </td>
                                    <td style={{ padding: "2px" }}>
                                      <b>{rowPercentage}</b>
                                    </td>
                                    <td style={{ padding: "2px" }}>
                                      <b>{grade}</b>
                                    </td>
                                  </tr>
                                );
                              })
                          ) : (
                            <tr>
                              <td colSpan="6" style={{ padding: "5px" }}>
                                {language === "English"
                                  ? "No data available"
                                  : "डेटा उपलब्ध नाही"}
                              </td>
                            </tr>
                          )}

                          {selectedStudentResults &&
                            selectedStudentResults.results && (
                              <>
                                <tr>
                                  <td colSpan="1" style={{ padding: "5px" }}>
                                    <b>
                                      {language === "English"
                                        ? "Total Marks"
                                        : "एकूण गुण"}
                                    </b>
                                  </td>
                                  <td colSpan="1" style={{ padding: "5px" }}>
                                    <b>
                                      {subjectSequence
                                        .filter((subject) => {
                                          const grades =
                                            selectedStudentResults.results[
                                              subject
                                            ] || {};
                                          return grades.obtainMarks;
                                        })
                                        .reduce((total, subject) => {
                                          const grades =
                                            selectedStudentResults.results[
                                              subject
                                            ] || {};
                                          return total + (grades.outOf || 0);
                                        }, 0)}
                                    </b>
                                  </td>
                                  <td
                                    colSpan="1"
                                    style={{ padding: "5px" }}
                                  ></td>
                                  <td colSpan="1" style={{ padding: "5px" }}>
                                    <b>
                                      {subjectSequence
                                        .filter((subject) => {
                                          const grades =
                                            selectedStudentResults.results[
                                              subject
                                            ] || {};
                                          return grades.obtainMarks;
                                        })
                                        .reduce((total, subject) => {
                                          const grades =
                                            selectedStudentResults.results[
                                              subject
                                            ] || {};
                                          return (
                                            total + (grades.obtainMarks || 0)
                                          );
                                        }, 0)}
                                    </b>
                                  </td>
                                  <td style={{ padding: "5px" }}>
                                    <b>
                                      {(() => {
                                        const filteredSubjects =
                                          subjectSequence.filter((subject) => {
                                            const grades =
                                              selectedStudentResults.results[
                                                subject
                                              ] || {};
                                            return grades.obtainMarks;
                                          });
                                        const totalMaxMarks =
                                          filteredSubjects.reduce(
                                            (total, subject) => {
                                              const grades =
                                                selectedStudentResults.results[
                                                  subject
                                                ] || {};
                                              return (
                                                total + (grades.outOf || 0)
                                              );
                                            },
                                            0
                                          );
                                        const totalObtainedMarks =
                                          filteredSubjects.reduce(
                                            (total, subject) => {
                                              const grades =
                                                selectedStudentResults.results[
                                                  subject
                                                ] || {};
                                              return (
                                                total +
                                                (grades.obtainMarks || 0)
                                              );
                                            },
                                            0
                                          );
                                        return totalMaxMarks > 0
                                          ? (
                                              (totalObtainedMarks /
                                                totalMaxMarks) *
                                              100
                                            ).toFixed(2) + "%"
                                          : "0%";
                                      })()}
                                    </b>
                                  </td>
                                  <td style={{ padding: "5px" }}>
                                    <b>
                                      {(() => {
                                        const filteredSubjects =
                                          subjectSequence.filter((subject) => {
                                            const grades =
                                              selectedStudentResults.results[
                                                subject
                                              ] || {};
                                            return grades.obtainMarks;
                                          });
                                        const totalMaxMarks =
                                          filteredSubjects.reduce(
                                            (total, subject) => {
                                              const grades =
                                                selectedStudentResults.results[
                                                  subject
                                                ] || {};
                                              return (
                                                total + (grades.outOf || 0)
                                              );
                                            },
                                            0
                                          );
                                        const totalObtainedMarks =
                                          filteredSubjects.reduce(
                                            (total, subject) => {
                                              const grades =
                                                selectedStudentResults.results[
                                                  subject
                                                ] || {};
                                              return (
                                                total +
                                                (grades.obtainMarks || 0)
                                              );
                                            },
                                            0
                                          );
                                        const percentage =
                                          totalMaxMarks > 0
                                            ? (totalObtainedMarks /
                                                totalMaxMarks) *
                                              100
                                            : 0;
                                        return language === "English"
                                          ? calculateGradeEnglish(percentage)
                                          : calculateGradeMarathi(percentage);
                                      })()}
                                    </b>
                                  </td>
                                </tr>
                              </>
                            )}
                        </tbody>
                      </table>
                    ) : (
                      <p
                        style={{
                          fontSize: "18px",
                          textAlign: "center",
                          marginTop: "20px",
                          color: "red",
                        }}
                      >
                        {language === "English"
                          ? "! No result available please fill marks."
                          : "कोणतेही प्रगतीपत्रक उपलब्ध नाहीत."}
                      </p>
                    )}
                    <div
                      style={{
                        marginTop: "10px",
                        fontSize: "14px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <p>
                          <strong>
                            {language === "English" ? "Out Of : " : "एकूण : "}
                            {subjectSequence
                              .filter((subject) => {
                                const grades =
                                  selectedStudentResults?.results?.[subject] ||
                                  {};
                                return grades.obtainMarks;
                              })
                              .reduce((total, subject) => {
                                const grades =
                                  selectedStudentResults?.results?.[subject] ||
                                  {};
                                return total + (grades.outOf || 0);
                              }, 0)}
                          </strong>
                        </p>
                        <p>
                          <strong>
                            {language === "English"
                              ? "Obtained Marks : "
                              : "प्राप्त गुण : "}
                            {subjectSequence.reduce((total, subject) => {
                              const grades =
                                selectedStudentResults?.results?.[subject] ||
                                {};
                              return (
                                total +
                                (grades.unitTestIObtainMarks || 0) +
                                (grades.unitTestIIObtainMarks || 0) +
                                (grades.obtainMarks || 0)
                              );
                            }, 0)}
                          </strong>
                        </p>
                      </div>
                      <div>
                        <p>
                          <b>
                            {language === "English"
                              ? "Percentage : "
                              : "टक्केवारी : "}
                            {(() => {
                              const totalMaxMarks = subjectSequence.reduce(
                                (total, subject) => {
                                  const grades =
                                    selectedStudentResults?.results?.[
                                      subject
                                    ] || {};
                                  return total + (grades.outOf || 0);
                                },
                                0
                              );
                              const totalObtainedMarks = subjectSequence.reduce(
                                (total, subject) => {
                                  const grades =
                                    selectedStudentResults?.results?.[
                                      subject
                                    ] || {};
                                  return total + (grades.obtainMarks || 0);
                                },
                                0
                              );

                              // Calculate percentage
                                return totalMaxMarks > 0
                                ? (
                                  (totalObtainedMarks / totalMaxMarks) *
                                  100
                                  ).toFixed(2) + "%"
                                : "0%";
                              })()}
                              </b>
                            </p>
                            </div>
                          </div>
                          {selectedStudentResults &&
                    selectedStudentResults.results ? (
                      <div>
                        <table
                          className="table table-striped table-bordered"
                          style={{ fontSize: "12px", padding: "5px" }}
                        >
                          {/* Your table code here */}
                        </table>
                        {selectedStudentResults.results.remark && typeof selectedStudentResults.results.remark === "string" && (
                          <div style={{ marginTop: "10px" }}>
                            <p>
                              <strong>
                                {language === "English"
                                  ? "Remark : "
                                  : "टिप्पणी : "}
                                {selectedStudentResults.results.remark}
                              </strong>
                            </p>
                          </div>
                        )}
                      </div>
                    ) : (
                      <p
                        style={{
                          fontSize: "18px",
                          textAlign: "center",
                          marginTop: "20px",
                          color: "red",
                        }}
                      >
                        {language === "English"
                          ? "! No result available please fill marks."
                          : "कोणतेही प्रगतीपत्रक उपलब्ध नाहीत."}
                      </p>
                    )}

                          <div
                            className="grad"
                            style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "0 20px",
                            }}
                          >
                            {/* Left-aligned label */}
                      <label
                        style={{
                          flex: 1,
                          textAlign: "left",
                          marginBottom: "2px",
                          marginLeft: "-10px",
                        }}
                        htmlFor="Parent's signature"
                      >
                        {language === "English"
                          ? "Parent's signature"
                          : "पालकांची सही"}
                      </label>
                      {/* Center-aligned label */}
                      <label
                        style={{
                          flex: 1,
                          textAlign: "center",
                          marginBottom: "2px",
                        }}
                        htmlFor="class-teacher"
                      >
                        {language === "English"
                          ? "Class Teacher"
                          : "वर्गशिक्षक"}
                      </label>

                      {/* Right-aligned label */}
                      <label
                        style={{
                          flex: 1,
                          textAlign: "right",
                          marginBottom: "2px",
                          marginRight: "20px",
                        }}
                        htmlFor="principal"
                      >
                        {language === "English" ? "Principal" : "प्राचार्य"}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Modal.Body>
         
        </Modal>
      </div>
    </div>
  );
}

export default WebPrelimResult;

